import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ e("circle", {
  cx: "12",
  cy: "12.444",
  r: "10",
  fill: "#fff"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "#1F2937",
  d: "M12 2.444a10 10 0 1 0 0 20 10 10 0 0 0 0-20m4.3 7.61-4.57 6a1 1 0 0 1-1.229.292 1 1 0 0 1-.351-.282l-2.44-3.11a1 1 0 1 1 1.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 1 1 1.6 1.22z"
}, null, -1), r = [
  l,
  n
];
function s(a, i) {
  return t(), o("svg", c, [...r]);
}
const d = { render: s };
export {
  d as default,
  s as render
};
